import React, { useState } from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const MessageAppScanError = (props) => {
  return (
    <div className="text-start">
      <Paragraph>
        The detection application experienced errors during its detection
        process and was not able to gather the necessary data to accurately
        analyze this computer.
      </Paragraph>
      <Paragraph>
        The detection application must be downloaded and run again.
      </Paragraph>
      <Paragraph>
        You can retry the detection process (recommended) or cancel the
        detection.
      </Paragraph>
    </div>
  );
};

export default MessageAppScanError;
